function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "34px",
    height: "31px",
    viewBox: "0 0 33 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "current",
      fillOpacity: 1
    },
    d: "M 2.273438 29.734375 L 2.738281 30.054688 C 3.644531 30.671875 4.703125 31 5.789062 31 L 27.210938 31 C 28.296875 31 29.355469 30.671875 30.261719 30.054688 L 30.726562 29.734375 C 32.144531 28.765625 33 27.128906 33 25.378906 C 33 24.445312 32.757812 23.53125 32.292969 22.726562 L 20.644531 2.429688 C 19.78125 0.925781 18.203125 0 16.5 0 C 14.796875 0 13.21875 0.925781 12.355469 2.429688 L 0.707031 22.726562 C 0.242188 23.53125 0 24.445312 0 25.378906 C 0 27.128906 0.855469 28.765625 2.273438 29.734375 Z M 17.875 19.726562 L 19.25 7.046875 L 13.75 7.046875 L 15.125 19.726562 Z M 19.25 25.363281 C 19.25 23.808594 18.019531 22.546875 16.5 22.546875 C 14.980469 22.546875 13.75 23.808594 13.75 25.363281 C 13.75 26.921875 14.980469 28.183594 16.5 28.183594 C 18.019531 28.183594 19.25 26.921875 19.25 25.363281 Z M 19.25 25.363281 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.99699f9288a4098aa908fe6f94e558f1.svg";
export { ForwardRef as ReactComponent };